export default __webpack_public_path__ + "static/8_24-966b793db0b95f0dc6c2fa9b99dd40bb.png";